<template>
    <div class="add-platform-account">
        <div class="content">
            <div class="data-title">
                <div class="title-name">新增平台账号</div>
            </div>
            <div class="text">基础信息</div>
            <!-- 新增的表单 -->
            <platform-account-form ref="platformAccountForm" ></platform-account-form>
            <div class="footer" :class="[isCollapsed ? 'footer-collapsed' : '']">
                <el-button type="info" plain @click="back">返回</el-button>
                <el-button type="primary" plain @click="reset">重置</el-button>
                <el-button type="primary" @click="save" :loading="btnSave">保存</el-button>
            </div>
        </div>
    </div>

</template>
<script>
import platformAccountForm from "@/pages/assetManagement/common/platformAccountForm.vue";
export default {
    name: 'platformAccountAdd',
    components: {platformAccountForm},

    data() {
        return {
             btnSave: false,
            
        }
    },
     activated() {
        this.reset() 
    },

    computed: {
        isCollapsed() {
            return this.$store.state.isCollapsed
        }
    },
    methods: {
        back() {
            this.$router.go(-1)
        },
        reset() {
            this.$refs.platformAccountForm.reset()
        },
        save() {
            this.$refs.platformAccountForm.save()
        }
    },
}
</script>
<style lang="scss" scoped >
.content {
    width: 100%;
    min-height: calc(100vh - 118px);
    margin-top: 16px;
    padding: 0 16px;
    box-sizing: border-box;
    margin-bottom: 35px;
    background-color: #FFFFFF;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    flex: 1;
}
.data-title {
    width: 100%;
    height: 32px;
    margin-top: 20px;
    position: relative;
    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 9px;
        width: 2px;
        height: 16px;
        background: #00B498;
        border-radius: 0px 0px 0px 0px;
    }
    .title-name {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 18px;
        color: #2F3030;
        margin-left: 6px;
        line-height: 32px;
    }

}
.text {
    font-family: PingFang SC, PingFang SC;
    font-weight: bold;
    font-size: 16px;
    color: #2F3030;
    margin-top: 32px;
    margin-bottom: 30px;
}



/* 底部按钮 */
.footer {
    height: 84px;
    background: #FFFFFF;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 200px;
    right: 0;
    bottom: 0;
    border-top: 1px solid #EDF2F2;
    box-sizing: border-box;
    transition: left 0.3s ease-in-out;
    z-index: 2;

    .el-button {
        min-width: 88px;
        padding: 12px 20px 10px;
    }

    .el-button+.el-button {
        margin-left: 16px;
    }
}

.footer-collapsed {
    left: 80px;
}
</style>
